module.exports = __webpack_public_path__ + "img/1_4.dbc03dc5.png";